//----------------------------------
// get combatant filter index by id
//----------------------------------
export default function getCombatantFilterIndexById(combatants, id) {
  // console.log("----------------------")
  // console.log("IN getCombatantFilterIndexById")
  //---------
  // get idx
  //---------
  const idx = combatants.findIndex((i) => i.id == id)
  //---------
  // returns
  //---------
  return idx;
}
